import {eventChannel} from 'redux-saga';

/**
 * @see https://github.com/redux-saga/redux-saga/blob/master/docs/advanced/Channels.md#using-the-eventchannel-factory-to-connect-to-external-events
 */
export function callInterval(duration: number) {
  return eventChannel(emitter => {
    let timer: any;

    const recursiveTimer = () => {
      timer = setTimeout(() => {
        emitter(true);
        recursiveTimer();
      }, duration);
    };

    recursiveTimer();

    // unsubscribe
    return () => clearTimeout(timer);
  });
}
